import { render } from "./Select2Test.vue?vue&type=template&id=56e9eea9"
import script from "./Select2Test.vue?vue&type=script&lang=js"
export * from "./Select2Test.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__